import { render } from "./AppConfigComponent.vue?vue&type=template&id=1672afaa&scoped=true"
import script from "./AppConfigComponent.vue?vue&type=script&lang=js"
export * from "./AppConfigComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1672afaa"

export default script